import { render, staticRenderFns } from "./ReservationService.vue?vue&type=template&id=740e4daa&scoped=true&"
import script from "./ReservationService.vue?vue&type=script&lang=js&"
export * from "./ReservationService.vue?vue&type=script&lang=js&"
import style0 from "./ReservationService.vue?vue&type=style&index=0&id=740e4daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e4daa",
  null
  
)

export default component.exports